import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module'
import { ServicerRoutingModule } from './servicer-routing.module';
import { ServicerComponent } from './servicer.component';
import { ServicerNavComponent } from './components/servicer-nav/servicer-nav.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RmdTrackerServicerComponent } from './components/rmd-tracker-servicer/rmd-tracker-servicer.component';
import { AdvisorListComponent } from './components/advisor-list/advisor-list.component';
import { ServicerListComponent } from './components/servicer-list/servicer-list.component';


@NgModule({
  declarations: [
    ServicerComponent,
    ServicerNavComponent,
    DashboardComponent,
    RmdTrackerServicerComponent,
    AdvisorListComponent,
    ServicerListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ServicerRoutingModule,
  ],
  exports: [
    ServicerNavComponent
  ]
})
export class ServicerModule { }
